// extracted by mini-css-extract-plugin
export default {"container":"activityDetails_container__tW3z6","profileName":"activityDetails_profileName__7Ghzk","username":"activityDetails_username__jXt7K"};